import actions from "./actions";
import labels from "./labels";
import categories from "./categories";
import GTMEvents from "./GTMEvents";

export default {
  action: actions,
  label: labels,
  category: categories,
  GTMEvent: GTMEvents,
};



// WEBPACK FOOTER //
// ./src/analytics/eventFactory/index.js